import { all, takeLatest, fork, put } from 'redux-saga/effects';
import actions from "./actions";
import statusActions from "./../status/actions";
import featureActions from "../../redux/feature/actions";
import { getQuery, postQuery } from 'utils/api';
import { getDefaultPallet } from 'utils/common';

export function* getColours() {
  yield takeLatest(actions.GET_COLOURS_REQUEST, function* getPalletRequest() {
    try {
      //const response = yield getQuery(`colors?ajax=1`);
      const rootElement = document.getElementById('root');
      const getColoursEndPoint = rootElement?.getAttribute('data-getcolors') || '';

      const response = yield getQuery(getColoursEndPoint);
      // const response = yield getQuery(`/colour-tempdata.json`);
      //const response = yield getQuery(`https://clay.powdev.lt/en/module/revisualizer/colors?ajax=1`);
      if(response.status === 200) {
        yield put({
          type: actions.GET_COLOURS_REQUEST_SUCCESS,
          payload: response.data,
        });
      }
    } catch (e) {
      console.log(e);
    }
  });
}

export function* getObjects() {
  yield takeLatest(actions.GET_OBJECTS_REQUEST, function* getObjectsRequest() {
    try {
      const rootElement = document.getElementById('root');
      const getObjectsEndPoint = rootElement?.getAttribute('data-getobjects') || '';

      //const response = yield getQuery(`objects?ajax=1&action=getObjects`);
      const response = yield getQuery(getObjectsEndPoint);
      if(response.status === 200) {
        const objects = response.data;
        yield put({
          type: actions.GET_OBJECTS_REQUEST_SUCCESS,
          payload: objects, // or full response.data.data if needed
        });
      }
    } catch (e) {
      console.log(e);
    }
  });
}

// export function* getObjects() {
//   yield takeLatest(actions.GET_OBJECTS_REQUEST, function* getObjectsRequest() {
//     try {
//       yield put({
//         type: actions.GET_OBJECTS_REQUEST_SUCCESS,
//         payload: [
//           {
//             "objectId": "10",
//             "objectName": "Bedroom - 10",
//             "object": {
//               "objectName": "Bedroom",
//               "userColours": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "https://clay.powdev.lt/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ],
//               "priceData": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "3",
//                   "visible": true
//                 }
//               ]
//             }
//           },
//           {
//             "objectId": "11",
//             "objectName": "Bathroom - 11",
//             "object": {
//               "objectName": "Bathroom",
//               "userColours": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "https://clay.powdev.lt/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 54.545455,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ],
//               "priceData": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "https://clay.powdev.lt/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 54.545455,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ]
//             }
//           },
//           {
//             "objectId": "12",
//             "objectName": "Bathroom - 12",
//             "object": {
//               "objectName": "Bathroom",
//               "userColours": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "https://clay.powdev.lt/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 54.545455,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ],
//               "priceData": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "https://clay.powdev.lt/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 54.545455,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ]
//             }
//           },
//           {
//             "objectId": "13",
//             "objectName": "Bathroom - 13",
//             "object": {
//               "objectName": "Bathroom",
//               "userColours": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "https://clay.powdev.lt/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 54.545455,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ],
//               "priceData": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "https://clay.powdev.lt/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 54.545455,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ]
//             }
//           },
//           {
//             "objectId": "14",
//             "objectName": "Bedroom - 14",
//             "object": {
//               "objectName": "Bedroom",
//               "userColours": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ],
//               "priceData": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "3",
//                   "visible": true
//                 }
//               ]
//             }
//           },
//           {
//             "objectId": "15",
//             "objectName": "Bedroom - 15",
//             "object": {
//               "objectName": "Bedroom",
//               "userColours": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ],
//               "priceData": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "3",
//                   "visible": true
//                 }
//               ]
//             }
//           },
//           {
//             "objectId": "16",
//             "objectName": "Bedroom - 16",
//             "object": {
//               "objectName": "Bedroom",
//               "userColours": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 86,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 }
//               ],
//               "priceData": [
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "12_B",
//                   "color_image": "/img/co/33.jpg",
//                   "id_product_attribute": "75",
//                   "price": 66,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "WHITE decorative clay plaster 0-0,5 mm",
//                   "color_name": "2_B",
//                   "color_image": "https://clay.powdev.lt/img/co/30.jpg",
//                   "id_product_attribute": "68",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": 16,
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "23_B",
//                   "color_image": "https://clay.powdev.lt/img/co/35.jpg",
//                   "id_product_attribute": "77",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "1.4",
//                   "visible": true
//                 },
//                 {
//                   "id_product": 72451,
//                   "product_name": "BALTAS apdailinis molio tinkas 0-0,5 mm",
//                   "color_name": "24_B",
//                   "color_image": "https://clay.powdev.lt/img/co/36.jpg",
//                   "id_product_attribute": "78",
//                   "price": 0,
//                   "weight": "25 kg",
//                   "m2": "3",
//                   "visible": true
//                 }
//               ]
//             }
//           }
//         ], // or full response.data.data if needed
//       });
//     } catch (e) {
//       console.log(e);
//     }
//   });
// }

export function* setObjects() {
  yield takeLatest(actions.SET_OBJECTS_REQUEST, function* setObjectsRequest(payload) {
    try {
      const rootElement = document.getElementById('root');
      const setObjectsEndPoint = rootElement?.getAttribute('data-setobjects') || '';
      const response = yield postQuery(
        //`objects?ajax=1`,
        setObjectsEndPoint,
        {
          action: 'setObject',
          // customerId: payload.payload.customerId,
          // name: `${payload.payload.customerId}-objects`,
          objectId: payload.payload.objectId,
          objectName: payload.payload.objectName,
          object: payload.payload.object
        }
      );
      if(response.status === 200) {

        const data = response?.data || response; // adjust based on postQuery's return type
        
        if (data.success) {
          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "success",
              message: "Project is saved successfully"
            },
          });
        } else {
          const errorMessage =
            data?.errors?.[0]?.error ||
            data?.message ||
            "Saving failed. Please try again.";

          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "error",
              message: errorMessage,
            },
          });
        }

      }
    } catch (e) {
      yield put({
        type: actions.OPEN_TOAST,
        payload: {
          isOpen: true,
          status: "error",
          message: "Project saving is failed"
        },
      });
    }
  });
}

export function* addProducts() {
  yield takeLatest(actions.ADD_PRODUCTS_REQUEST, function* addProductsRequest(payload) {
    try {
      const response = yield postQuery(
        `cart?ajax=1`,
        {
          products: payload,
        }
      );
      if(response.status === 200) {
        console.log('addProducts success');
      }
    } catch (e) {
      console.log(e);
    }
  });
}

export function* addToCart() {
  yield takeLatest(actions.ADD_TO_CART_REQUEST, function* addToCartRequest(payload) {
    const rootElement = document.getElementById('root');
    const addToCartEndPoint = rootElement?.getAttribute('data-addtocart') || '';
    const cartPath = rootElement?.getAttribute('data-cart') || '';
    try {
      const response = yield postQuery(
        //`cart?ajax=1`,
        addToCartEndPoint,
        {
          customerId : payload.payload.customerId,
          products: payload.payload.priceData,
        }
      );
      if(response.status === 200) {
        const data = response?.data || response; // depends on postQuery's return

        if (data.success) {
          // Redirect to cart page
          if (cartPath) {
            window.location.href = cartPath;
          }
        } else {
          const errorMessage =
            data?.errors?.[0]?.error ||
            data?.message ||
            "Add to cart failed. Please check the product data.";

          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "error",
              message: errorMessage,
            },
          });
        }

      }
    } catch (e) {
      yield put({
        type: actions.OPEN_TOAST,
        payload: {
          isOpen: true,
          status: "error",
          message: "Add to cart is failed"
        },
      });
    }
  });
}

export function* defaultPalletRequest() {
  yield takeLatest(actions.GET_DEFAULT_PALLET_REQUEST, function* () {
    try {
      const rootElement = document.getElementById('root');
      const getDefaultPalletEndPoint = rootElement?.getAttribute('data-getpallets') || '';

      const response = yield getQuery(getDefaultPalletEndPoint);

      if(response.status === 200) {
        const defaultPalletData = getDefaultPallet(response.data.objects);
        yield put({
          type: actions.CREATE_USER_COLOURS,
          payload: {...defaultPalletData},
        });
      }
    } catch (e) {
      console.log(e);
    }
  });
}

export function* setPallet() {
  yield takeLatest(actions.SET_PALLET_REQUEST, function* setPalletRequest(param) {
    try {
      const rootElement = document.getElementById('root');
      const setPalletsEndPoint = rootElement?.getAttribute('data-setpallets') || '';

      const response = yield postQuery(
        //`objects?ajax=1`,
        setPalletsEndPoint,
        {
          action: 'setPallets',
          payload: param.payload,
        }
      );
      if(response.status === 200) {
        const data = response?.data || response;
        if (data.success) {
          let successMessage = "Pallet action completed successfully";
          if (param.payload.type === "create") {
            successMessage = "Pallet is created successfully";
          } else if (param.payload.type === "update") {
            successMessage = "Pallet is saved successfully";
          } else if (param.payload.type === "delete") {
            successMessage = "Pallet is deleted successfully";
          }

          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "success",
              message: successMessage,
            },
          });
        } else {
          const errorMessage =
            data?.errors?.[0]?.error ||
            data?.message ||
            "Pallet action failed. Please check your input.";

          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "error",
              message: errorMessage,
            },
          });
        }

      }
    } catch (e) {
      
      let errorMessage = "Pallet action failed due to a system error";
      if (param.payload.type === "create") {
        errorMessage = "Pallet creating is failed";
      } else if (param.payload.type === "update") {
        errorMessage = "Pallet saving is failed";
      } else if (param.payload.type === "delete") {
        errorMessage = "Pallet deleting is failed";
      }

      yield put({
        type: actions.OPEN_TOAST,
        payload: {
          isOpen: true,
          status: "error",
          message: errorMessage,
        },
      });

    }
  });
}

export function* createProject() {
  yield takeLatest(actions.CREAT_PROJECT_REQUEST, function* createProjectRequest(payload) {
    try {
      // yield put({
      //   type: actions.CREAT_PROJECT_REQUEST_SUCCESS,
      //   payload
      // });

      const rootElement = document.getElementById('root');
      const setObjectsEndPoint = rootElement?.getAttribute('data-createObject') || '';
      const _payload = {
        action: 'createObject',
        //objectId: payload.payload.objectID,
        objectName: payload.payload.objectName,
        object: payload.payload.object
      }
      const response = yield postQuery(
        //`objects?ajax=1`,
        setObjectsEndPoint,
        _payload
      );

      if(response.status === 200) {

        const data = response?.data || response; // adjust based on postQuery's return type
        
        if (data.success) {
          yield put({
            type: actions.CREAT_PROJECT_REQUEST_SUCCESS,
            payload: {
              ..._payload,
              objectID: data.objectId
            }
          });
          
          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "success",
              message: "Project is created successfully"
            },
          });
        } else {
          const errorMessage =
            data?.errors?.[0]?.error ||
            data?.message ||
            "Project creating is failed. Please try again.";

          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "error",
              message: errorMessage,
            },
          });
        }

      }
    } catch (e) {
      yield put({
        type: actions.OPEN_TOAST,
        payload: {
          isOpen: true,
          status: "error",
          message: "Project creating is failed",
        },
      });
    }
  });
}

export function* deleteProject() {
  yield takeLatest(actions.DELET_PROJECT_REQUEST, function* deleteProjectRequest(payload) {
    try {
      const rootElement = document.getElementById('root');
      const deleteProjectEndpoint = rootElement?.getAttribute('data-deleteObject') || '';
      
      // yield put({
      //   type: actions.DELET_PROJECT_REQUEST_SUCCESS,
      //   payload
      // });

      const response = yield postQuery(
        //`objects?ajax=1`,
        deleteProjectEndpoint,
        {
          action: 'deleteObject',
          objectId: payload.payload.objectID,
        }
      );
      
      if(response.status === 200) {

        const data = response?.data || response; // adjust based on postQuery's return type
        
        if (data.success) {
          yield put({
            type: actions.DELET_PROJECT_REQUEST_SUCCESS,
            payload
          });

          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "success",
              message: "Project is deleted successfully"
            },
          });
        } else {
          const errorMessage =
            data?.errors?.[0]?.error ||
            data?.message ||
            "Project deleting is failed.";

          yield put({
            type: actions.OPEN_TOAST,
            payload: {
              isOpen: true,
              status: "error",
              message: errorMessage,
            },
          });
        }
      }

    } catch (e) {
      yield put({
        type: actions.OPEN_TOAST,
        payload: {
          isOpen: true,
          status: "error",
          message: "Project deleting is failed.",
        },
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getColours),
    fork(setObjects),
    fork(getObjects),
    fork(addProducts),
    fork(addToCart),
    fork(defaultPalletRequest),
    fork(setPallet),
    fork(createProject),
    fork(deleteProject)
  ]);
}